// extracted by mini-css-extract-plugin
export default {"faqs":"HOIBajBNeOKYu7MNa5UQ","h2":"x0cMG9jwZU7RbIbwITEK"};